// Port dla konceptu "żywy" (t_3d96c476) z store-integration/preview/assets/cart/cart-model.js
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AltivestCartModel = api;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const KEY='altivest:cart:v1', SCHEMA='altivest-cart/v1';
  const modes={none:'Brak',text:'Tekst',motif:'Gotowy wzór',both:'Tekst + gotowy wzór'};
  function normalize(value) {
    if (!value || value.schema !== SCHEMA || !Array.isArray(value.items)) throw new Error('Nieprawidłowy zapis koszyka.');
    const seen=new Set();
    return {schema:SCHEMA,items:value.items.map(item => {
      if (!item || typeof item.key !== 'string' || !item.key || seen.has(item.key) || typeof item.model !== 'string' || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('Nieprawidłowa pozycja koszyka.');
      seen.add(item.key);
      if (item.properties && (typeof item.properties !== 'object' || Array.isArray(item.properties))) throw new Error('Nieprawidłowa personalizacja.');
      const properties={};
      for (const [k,v] of Object.entries(item.properties || {})) { if (typeof v === 'string' && v !== '') properties[k]=v.normalize('NFC'); }
      return {...item,properties};
    })};
  }
  function publicProperties(properties) {
    const mode=properties._cfg_mode || Object.keys(modes).find(k=>modes[k]===properties.Personalizacja);
    const keys=['Kolor','Rozmiar','Personalizacja','Przewidywany czas'];
    if (mode && mode!=='none') keys.push('Miejsce','Podgląd');
    if (['text','both'].includes(mode)) keys.push('Tekst haftu','Krój pisma','Kolor nici');
    if (['motif','both'].includes(mode)) keys.push('Motyw');
    return keys.filter(k=>properties[k]).map(k=>[k,properties[k]]);
  }
  function quote(item,catalog) {
    const product=catalog.products?.find(p=>p.model===item.model);
    const variant=product?.variants?.find(v=>String(v.shopifyVariantId ?? v.variantId)===String(item.variantId));
    const record=variant || product;
    const displayPriceMinor=Number.isSafeInteger(record?.priceMinor)&&record.priceMinor>=0?record.priceMinor:0;
    const id=record?.shopifyVariantId ?? record?.variantId;
    const personalized=(item.properties?._cfg_mode && item.properties._cfg_mode!=='none') || (item.properties?.Personalizacja && item.properties.Personalizacja!=='Brak');
    if (!record || !id || String(id)!==String(item.variantId) || record.approvalStatus!=='approved' || record.available!==true || !Number.isSafeInteger(record.priceMinor) || record.priceMinor<0 || !/^[A-Z]{3}$/.test(record.currency || '') || personalized) return {product,displayPriceMinor,priceMinor:null,currency:null};
    const total=record.priceMinor*item.quantity;
    if (!Number.isSafeInteger(total)) return {product,priceMinor:null,currency:null};
    return {product,displayPriceMinor,priceMinor:record.priceMinor,totalMinor:total,currency:record.currency};
  }
  function subtotal(items,catalog) {
    let total=0,currency=null;
    for (const item of items) {
      const q=quote(item,catalog);
      if (q.priceMinor===null || (currency && currency!==q.currency)) return null;
      currency=q.currency; total+=q.totalMinor;
      if (!Number.isSafeInteger(total)) return null;
    }
    return {amountMinor:total,currency:currency || 'PLN'};
  }
  function update(state,key,quantity) {
    if (!Number.isSafeInteger(quantity) || quantity<1) throw new Error('Podaj dodatnią, całkowitą liczbę sztuk.');
    const item=state.items.find(i=>i.key===key);
    if (!item) throw new Error('Pozycja nie jest już w koszyku.');
    if (item.properties._cfg_bundle_id) throw new Error('Ilość zestawu z dopłatą wymaga ponownej wyceny. Usuń cały zestaw i wróć do produktu.');
    return normalize({...state,items:state.items.map(i=>i.key===key?{...i,quantity}:i)});
  }
  function remove(state,key) {
    const item=state.items.find(i=>i.key===key), bundle=item?.properties._cfg_bundle_id;
    return normalize({...state,items:state.items.filter(i=>i.key!==key && (!bundle || i.properties._cfg_bundle_id!==bundle))});
  }
  return Object.freeze({KEY,SCHEMA,normalize,publicProperties,quote,subtotal,update,remove});
});
